'use client'

import { useDeviceType } from 'hooks/useDeviceType'
import { AnimatePresence, motion } from 'motion/react'
import ArrowLeft from 'public/assets/arrow-left.svg'
import ArrowRight from 'public/assets/arrow-right.svg'
import { useState } from 'react'
import styles from './Testimonials.module.scss'

interface Testimonial {
  text: string
  name: string
  position: string
  image: string
  imageTablet: string
  imageMobile: string
}

const quotes: Testimonial[] = [
  {
    text: "“I like the workflow we've set up over the years which includes code reviews and testing by our QA team, but my favourite activity is probably our weekly Coffee Time meeting where we get to share any problems we might have with a particular task and tackle it together as a team.”",
    name: 'Gordan',
    position: 'Software Engineer',
    image: '/assets/careers/gordan.webp',
    imageTablet: '/assets/careers/gordan-1024w.webp',
    imageMobile: '/assets/careers/gordan-425w.webp',
  },
  {
    text: "“Working on challenging projects motivates me to always do and be better. I'm constantly learning about new and interesting topics and techniques so that I can introduce them to my everyday workflow.”",
    name: 'Ena',
    position: 'Product Designer',
    image: '/assets/careers/ena.webp',
    imageTablet: '/assets/careers/ena-1024w.webp',
    imageMobile: '/assets/careers/ena-425w.webp',
  },
  {
    text: "“A supportive and pressure-free environment has helped me to advance my skills even further and it opened doors to learn the new ones. Every day is a challenge, and I mean in the best possible way... And, if you wonder how is that a good thing, I'll tell you. You are never alone. People at Pixion have your back.”",
    name: 'Marin',
    position: 'Software Engineer',
    image: '/assets/careers/marin.webp',
    imageTablet: '/assets/careers/marin-1024w.webp',
    imageMobile: '/assets/careers/marin-425w.webp',
  },
]

const Testimonials = () => {
  const [[currentIndex, direction], setCurrentIndex] = useState([0, 0])
  const currentQuote = quotes[currentIndex]
  const { isMobile, isTablet } = useDeviceType()

  function paginate(newDirection: number) {
    setCurrentIndex([currentIndex + newDirection, newDirection])
  }

  function enabledLeft() {
    return currentIndex > 0
  }

  function enabledRight() {
    return currentIndex < quotes.length - 1
  }

  const variants = {
    enter: (direction: number) => {
      return {
        x: direction > 0 ? '100%' : '-100%',
        opacity: 0,
      }
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction: number) => {
      return {
        zIndex: 0,
        x: direction < 0 ? '100%' : '-100%',
        opacity: 0,
      }
    },
  }

  return (
    <motion.section layoutRoot layout className={styles.container}>
      <motion.div layout='position' className={styles.image}></motion.div>

      <motion.div layout className={styles.content}>
        <motion.h2 layout='position' className={styles.title}>
          A small but mighty team that cares about every pixel
        </motion.h2>

        <motion.div layout className={styles['quote-container']}>
          <AnimatePresence initial={false} custom={direction} mode='wait'>
            <motion.div
              key={currentQuote.name}
              custom={direction}
              variants={variants}
              initial='enter'
              animate='center'
              exit='exit'
              transition={{
                duration: 0.3,
                ease: 'linear',
              }}
              className={styles.quote}
            >
              <div
                className={styles.portrait}
                style={{ backgroundImage: `url(${isMobile ? currentQuote.imageMobile : isTablet ? currentQuote.imageTablet : currentQuote.image})` }}
              />
              <div className={styles['text-container']}>
                <p className={styles.text}>{currentQuote.text}</p>
                <span className={styles.credit}>
                  {currentQuote.name},<br />
                  {currentQuote.position}
                </span>
              </div>
            </motion.div>
          </AnimatePresence>
        </motion.div>

        <div className={styles.arrows}>
          <ArrowLeft onClick={() => paginate(-1)} style={{ visibility: enabledLeft() ? 'initial' : 'hidden' }} />
          <ArrowRight onClick={() => paginate(1)} style={{ visibility: enabledRight() ? 'initial' : 'hidden' }} />
        </div>
      </motion.div>
    </motion.section>
  )
}

export default Testimonials
